export default __webpack_public_path__ + "6d26eec94674cf7c02a780701bc06913.png";